import styled from 'styled-components'

import { palette } from '../../theme/palette'

export const PatientReviewPaper = styled.div.attrs(() => ({
  'data-test': 'confirmation-pop-up'
}))`
  border-radius: 10px;
  background: ${palette.white};
  width: 100%;
  box-sizing: border-box;
  outline: none;
  padding: 32px;
`

export const PatientReviewContent = styled.div`
  margin-bottom: 24px;
  color: ${palette.mainText};
  text-align: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  
  & h1 {
    margin: 0 0 16px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
  }
`

export const PatientReviewButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const PatientReviewButton = styled.button.attrs(() => ({
  tabIndex: 0
}))<{ agreeButton: boolean }>`
  width: 100%;
  min-height: 44px;
  padding: 8px 16px;
  box-sizing: border-box;
  border-radius: 12px;
  margin: 0 12px 0 0;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${props => props.agreeButton ? palette.white : palette.mainBlue};
  cursor: pointer;
  background: ${props => props.agreeButton ? palette.mainBlue : palette.white};
  box-shadow: ${props => props.agreeButton ? `0px 4px 12px rgba(67, 156, 215, 0.2)` : 'none'};
  border: 2px solid ${palette.transparent};

  &:last-child {
    margin: 0;
  }
  
  &:hover {
    background: ${props => props.agreeButton ? palette.primaryHoverState : palette.white};
    color: ${props => props.agreeButton ? palette.white : palette.primaryHoverState};
    box-shadow: ${props => props.agreeButton ? `0px 4px 16px rgba(67, 156, 215, 0.3)` : 'none'};
  }
  
  &:focus-visible {
    background: ${props => props.agreeButton ? palette.primaryFocusState : palette.white};
    color: ${props => props.agreeButton ? palette.white : palette.primaryFocusState};
    box-shadow: ${props => props.agreeButton ? `0px 4px 16px rgba(67, 156, 215, 0.3)` : 'none'};
    outline: 2px solid ${palette.mainBlue};
  }
  
  &:active {
    background: ${props => props.agreeButton ? palette.primaryClickState : palette.white};
    color: ${props => props.agreeButton ? palette.white : palette.primaryClickState};
    box-shadow: none;
  }
`
